import { UserFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const UserPersistenceProvider = createStaticContextProvider(
  UserFirestorePersistenceContext,
  lazyValue(() =>
    import("./user-persistence").then((module) => module.userPersistence),
  ),
);
